import { isPlatformBrowser, Location } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, PLATFORM_ID } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService, RoutingService } from '@spartacus/core';
import { ProductListItemComponent, ProductListItemContextSource } from '@spartacus/storefront';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { KbGetAQuoteService } from '../../kb-Get-A-Quote/kb-get-aquote/kb-get-aquote.service';
import { CheckAvailabilityDialogComponent } from '../check-availability-dialog/check-availability-dialog.component';
import { InputModalityDetector } from '@angular/cdk/a11y';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-kb-product-list-item',
  templateUrl: './kb-product-list-item.component.html',
  styleUrls: ['./kb-product-list-item.component.scss'],
  standalone: false
})
export class KbProductListItemComponent extends ProductListItemComponent {
  @Input() searchQuery: any;
  isLoggedIn: boolean = false;
  distributerType: string;
  fleetPrideGroup: any;
  currentParams: any;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  constructor(public authService: AuthService, public compareService: ProductListService,
    productListItemContextSource: ProductListItemContextSource,
    private router: Router, private location: Location, private dialog: MatDialog,
    private custIDService: CustomerIdService, private cdr: ChangeDetectorRef,
    private cookieService: CookieService, private getaQuoteService: KbGetAQuoteService,
  ) {
    super(productListItemContextSource)
    this.authService
      .isUserLoggedIn().pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      })
    if (isPlatformBrowser(this.platformId)) {
      this.distributerType = document.cookie.split(";")[1]?.split("=")[1]?.split("_")[2];
    }
  }


  checkAvailability(productCode) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'check-availability-popup';
    dialogConfig.data = { productCode, page: 'PLP' };
    const dialogRef = this.dialog.open(CheckAvailabilityDialogComponent, dialogConfig);
  }
  ngOnInit() {
    this.custIDService.fleetPrideGroup$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    })
  }

  createAQuote(productId) {
    const custId = this.cookieService.getCookieValue(`customerIdNA`);
    if (this.cookieService.checkItemSessionStorage(custId)) {
      const quoteId = this.cookieService.getItemSessionStorage(custId);
      this.getaQuoteService.createQuoteId(productId, false, quoteId).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.routeToQuotePage(res.code);
      });
    } else {
      this.getaQuoteService.createQuoteId(productId, true).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        this.cookieService.setItemSessionStorage(custId, res?.code);
        this.routeToQuotePage(res.code);
      });
    }
  }
  routeToQuotePage(quoteId) {
    this.router.navigate(['quote'], { queryParams: { code: quoteId } });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
